import React, { type ReactNode } from "react";
import { useInView } from "react-intersection-observer";

import styles from "@fwa/src/components/BubbleCard/styles.module.css";

export const BubbleCard = ({
  children,
  imageChild,
  imageUrl,
  alt,
  imageRight = true,
  variation = 4,
  thirdBubbleColor,
  isAnimated = true,
}: {
  imageUrl?: string;
  imageChild?: ReactNode;
  alt?: string;
  children?: ReactNode;
  imageRight?: boolean;
  variation?: number;
  thirdBubbleColor?: string;
  isAnimated?: boolean;
}) => {
  const { ref: bubbleRef, inView } = useInView({
    triggerOnce: true,
  });

  return (
    <div
      className={styles["outer-wrapper"]}
      data-is-image-right={imageRight}
      ref={bubbleRef}
    >
      <div
        className={styles["bubble-wrapper"]}
        data-in-view={inView}
        data-is-animated={isAnimated}
      >
        <div
          className={styles["bubble"]}
          data-bubble="bubble1"
          data-variation={variation}
          data-in-view={inView}
          data-is-animated={isAnimated}
          style={{ backgroundColor: "var(--clr-primary, #000)" }}
        />
        <div
          className={styles["bubble"]}
          data-bubble="bubble2"
          data-variation={variation}
          data-in-view={inView}
          data-is-animated={isAnimated}
          style={{ backgroundColor: "var(--clr-secondary, #000)" }}
        />
        <div
          className={styles["bubble"]}
          data-bubble="bubble3"
          data-variation={variation}
          data-in-view={inView}
          data-is-animated={isAnimated}
          style={{
            backgroundColor: thirdBubbleColor ?? "var(--clr-tertiary, #000)",
          }}
        />
        {imageUrl ? (
          <div className={styles["image-rounded-wrapper"]}>
            <img src={imageUrl} alt={alt} />
          </div>
        ) : null}

        {!imageUrl && imageChild ? (
          <div className={styles["children-wrapper"]}>{imageChild}</div>
        ) : null}
      </div>
      <div
        className={styles["content-wrapper"]}
        data-is-image-right={imageRight}
      >
        {children}
      </div>
    </div>
  );
};

export default BubbleCard;
